import { render } from "./MenuApprovalHistory.vue?vue&type=template&id=09baa0e0&scoped=true&ts=true"
import script from "./MenuApprovalHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuApprovalHistory.vue?vue&type=script&setup=true&lang=ts"

import "./MenuApprovalHistory.vue?vue&type=style&index=0&id=09baa0e0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09baa0e0"],['__file',"src/components/scan/admin/MenuApprovalHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09baa0e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09baa0e0', __exports__)) {
    console.log('reload')
    api.reload('09baa0e0', __exports__)
  }
  
  module.hot.accept("./MenuApprovalHistory.vue?vue&type=template&id=09baa0e0&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('09baa0e0', render)
  })

}


export default __exports__